import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import Edit2FillIcon from "remixicon-react/Edit2FillIcon";
import DeleteBin5FillIcon from "remixicon-react/DeleteBin5FillIcon";
import { deleteDynamicPricing } from "../../../core/actionCreators/dynamicPricingActionCreator";
import { DYNAMIC_PRICING_PAGE_HEADERS } from "../../../utils/constants";

export const DynamicPricingStatusPill = (props: { value: any, className?: string }) => {
    const { value, className = "" } = props
    const isEnabled = value === true || value === "true"
    return (
        <span className={`inline-block whitespace-nowrap px-1.5 py-0.5 rounded text-[11px] font-medium border ${isEnabled ? "bg-green-100 text-green-800 border-green-200" : "bg-red-100 text-red-800 border-red-200"} ${className}`}>
            {isEnabled ? "Enabled" : "Disabled"}
        </span>
    )
}

const DynamicPricingListItem = (props: any) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { data } = props;

    const updateNavigateHandler = (msn: string) => {
        navigate(`/dynamic-pricing/edit/${msn}`);
    };

    const deleteHandler = (msn: string) => {
        const isConfirmed = window.confirm(`Are you sure you want to delete mapping for ${msn}?`);
        if (isConfirmed) {
            dispatch(deleteDynamicPricing(msn, (success: boolean) => {
                if (success) {
                    // Page reload or state update is handled by saga/reducer
                    // In this project, window.location.reload() seems common but
                    // ideally we should just fetch the list again or update local state.
                    window.location.reload();
                }
            }));
        }
    };

    // The category code is only worth showing when there is a category to qualify.
    const formatCategory = (item: any) => {
        if (!item.category) return "—"
        return item.categoryCode ? `${item.category} (${item.categoryCode})` : item.category
    }

    if (!data || data.length === 0) {
        return (
            <tr>
                <td colSpan={DYNAMIC_PRICING_PAGE_HEADERS.length} className="px-4 py-12 text-center text-xs text-gray-500">
                    No mappings found.
                </td>
            </tr>
        );
    }

    return (
        <>
            {data.map((item: any) => (
                <tr key={item.productRef} className="[&:nth-child(odd)]:bg-[#f7f7f7]">
                    <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] font-medium w-[14%]">{item.productRef || "—"}</td>
                    <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] w-[24%]">{item.productName || "—"}</td>
                    <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] w-[18%]">{formatCategory(item)}</td>
                    <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] w-[12%]">{item.primaryCompetitor || "—"}</td>
                    <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] w-[10%]">
                        <DynamicPricingStatusPill value={item.dynamicPricingEnabled} />
                    </td>
                    <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] w-[8%]">{item.minGmPercentage != null ? `${item.minGmPercentage}%` : "—"}</td>
                    <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] w-[8%]">{item.maxGmPercentage != null ? `${item.maxGmPercentage}%` : "—"}</td>
                    <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] w-[6%]">
                        <div className="flex items-center gap-3">
                            <button
                                onClick={() => updateNavigateHandler(item.productRef)}
                                className="text-blue-600 hover:text-blue-800 transition-colors"
                                title="Edit"
                            >
                                <Edit2FillIcon size={16} />
                            </button>
                            <button
                                onClick={() => deleteHandler(item.productRef)}
                                className="text-red-600 hover:text-red-800 transition-colors"
                                title="Delete"
                            >
                                <DeleteBin5FillIcon size={16} />
                            </button>
                        </div>
                    </td>
                </tr>
            ))}
        </>
    );
};

export default DynamicPricingListItem;
